import React, {Component} from 'react';
import Navs from "../../components/Navs/Navs";
import Footer from "../../components/Footer/Footer";
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic"
import "./Information.scss"
import Pages from "../../components/Pages/Pages";

class Information extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                list: ["本地货源", "外地货源", "全国货源", "整车配货"],
                index: props.location.query ? props.location.query.tabsIndex : 0,
            },
            screen: {
                list: ["发布时间", "运费价格"],
                state: [true, true],
                index: 0,
            },
            pattern: {
                list: ["图", "文"],
                index: 0,
            },
            dataList: [],
            page: {
                count: 0,
                index: 1,
                size: 9,
            },
            picUrl: "",
            show: false,
            qrcode: ""
        }
    }

    componentDidMount() {
        this.getSourceList();
    }

    getSourceList() {
        let {tabs, screen, page} = this.state;
        let data = {
            type: tabs.index + 1,
            orderType: screen.index,
            pageNum: page.index,
            pageSize: page.size,
        }
        this.$axios.apiList.getSourceList(data)
            .then(res => {
                page.count = res.data.sourceData.total;
                this.setState({
                    dataList: res.data.sourceData.list,
                    picUrl: res.data.picUrl,
                    qrcode: res.data.qrcode
                })
            })
            .catch(error => {

            })
    }

    tabsClick(index) {
        let {tabs, page} = this.state;
        tabs.index = index;
        page.index = 1;
        this.getSourceList();
    }

    screenClick(index) {
        let {screen, page} = this.state;
        screen.index === index ? screen.state[index] = !screen.state[index] : screen.index = index;
        page.index = 1;
        this.getSourceList();
    }

    patternClick(index) {
        let {pattern} = this.state;
        pattern.index = index;
        this.setState({});
    }

    callbackPage(pageIndex) {
        let {page} = this.state;
        page.index = pageIndex;
        this.getSourceList();
    }

    render() {
        let {tabs, screen, pattern, dataList, page, picUrl, show, qrcode} = this.state;
        return (
            <div className="information">
                <div className="navs">
                    <Navs fullPageIndex={6}></Navs>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <ComTitle {...titleObj.information}></ComTitle>
                <div className="content">
                    <div className="content-tabs">
                        {
                            tabs.list.map((item, index) => {
                                return (
                                    <div className={`item${index === tabs.index ? " in" : ""}`}
                                         onClick={this.tabsClick.bind(this, index)}
                                         key={index}>
                                        {item}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="content-screen">
                        {
                            screen.list.map((item, index) => {
                                return (
                                    <div className={`screen${index === screen.index ? " screen-in" : ""}`}
                                         onClick={this.screenClick.bind(this, index)}
                                         key={index}>
                                        {item}
                                        <i className="iconfont icon-huoyuanxinxi-fabushijian1"></i>
                                        {/*{*/}
                                        {/*    screen.state[index] ?*/}
                                        {/*        <i className="iconfont icon-huoyuanxinxi-fabushijian1"></i> :*/}
                                        {/*        <i className="iconfont icon-huoyuanxinxi-fabushijian2"></i>*/}
                                        {/*}*/}
                                    </div>
                                )
                            })
                        }
                        {
                            pattern.list.map((item, index) => {
                                return (
                                    <div className={`pattern${index === pattern.index ? " pattern-in" : ""}`}
                                         onClick={this.patternClick.bind(this, index)}
                                         key={index}>
                                        {item}
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        pattern.index === 1 ?
                            <div className="list">
                                {
                                    dataList.map((item, index) => {
                                        return (
                                            <div className="list-item" key={index}>
                                                <div className="title">
                                                    {item.cargoName}
                                                </div>
                                                <div className="price">
                                                    ￥<span>{item.freight}</span>
                                                </div>
                                                <div className="wrapper">
                                                    <div className="address">
                                                        <div>
                                                            <i className="iconfont icon-huoyuanxinxi-qi"></i>
                                                            {item.loadPlace}
                                                        </div>
                                                        <div>
                                                            <i className="iconfont icon-huoyuanxinxi-zhong"></i>
                                                            {item.unloadPlace}
                                                        </div>
                                                    </div>
                                                    <div className="time">
                                                        <i className="iconfont icon-huoyuanxinxi-juli"></i>
                                                        运程约{item.durationStr} （直达）
                                                    </div>
                                                    <div className="address">
                                                        <div>
                                                            <i className="iconfont icon-huoyuanxinxi-zhuanghuoshijian"></i>
                                                            装货时间：{item.planPickTime} - {item.planArrivalTime}
                                                        </div>
                                                        <div>
                                                            <i className="iconfont icon-huoyuanxinxi-yunshujuli"></i>
                                                            运输距离：{item.distanceStr}km
                                                        </div>
                                                    </div>
                                                    <div className="btn" onClick={e => this.setState({show: true})}>
                                                        下单
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div> :
                            <div className="img-list clear">
                                {
                                    dataList.map(((item, index) => {
                                        return (
                                            <div className="img-item" key={index}>
                                                <div className="price">
                                                    ￥ {item.freight}
                                                </div>
                                                <div className="address">
                                                    <i className="iconfont icon-huoyuanxinxi-qi"></i>
                                                    {item.loadPlace}
                                                </div>
                                                <div className="address">
                                                    <i className="iconfont icon-huoyuanxinxi-zhong"></i>
                                                    {item.unloadPlace}
                                                </div>
                                                <div className="address">
                                                    <i className="iconfont icon-huoyuanxinxi-juli"></i>
                                                    运程约{item.durationStr} （直达）
                                                </div>
                                                <div className="title">
                                                    {item.cargoName}
                                                </div>
                                                <div className="time">
                                                    <div className="icon">
                                                        <i className="iconfont icon-huoyuanxinxi-zhuanghuoshijian"></i>
                                                    </div>
                                                    <div className="time-content">
                                                        <div className="time-title">装货时间：</div>
                                                        <div
                                                            className="time-text">{item.planPickTime} - {item.planArrivalTime}</div>
                                                    </div>
                                                </div>
                                                <div className="time">
                                                    <div className="icon">
                                                        <i className="iconfont icon-huoyuanxinxi-yunshujuli"></i>
                                                    </div>
                                                    <div className="time-content">
                                                        <div className="time-title">运输距离：</div>
                                                        <div className="time-text">{item.distanceStr}km</div>
                                                    </div>
                                                </div>
                                                <div className="img-btn img-btn-in"
                                                     onClick={e => this.setState({show: true})}>
                                                    下单
                                                </div>
                                            </div>
                                        )
                                    }))
                                }
                            </div>
                    }
                    {
                        page.count !== 0 && <Pages page={page} callback={this.callbackPage.bind(this)}></Pages>
                    }
                </div>
                <Footer></Footer>
                {
                    show &&
                    <div className="popup">
                        <div className="popup-content">
                            <div className="close" onClick={e => this.setState({show: false})}>×</div>
                            <div className="left">
                                <div className="text">
                                    一站式智慧物流平台
                                </div>
                            </div>
                            <div className="right">
                                <div className="title">
                                    承运人APP
                                </div>
                                <div className="icon">
                                    <img src={qrcode} alt=""/>
                                </div>
                                <div className="text">
                                    请使用手机描二维码下载下载后即可在手机端接货源
                                </div>
                                <a download="二维码" href={qrcode} className="popup-btn">扫描二维码下载</a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default Information;
